import { FC, useEffect } from "react";
import Dialog, { DialogTitle, DialogContent } from "@/components/Dialog";
import Typography from "@/components/Typography";
import Button from "@/components/Button";
import { useTrackers } from "@/hooks";
import styles from "./PaymentLockDialog.module.scss";

type Props = {
  onClose: () => void;
};

const PaymentLockDialog: FC<Props> = ({ onClose }) => {
  const { track } = useTrackers();

  useEffect(() => {
    track("Job Locked Payment Dialog Opened", {
      eventId: "job-locked-payment-dialog-opened",
    });
  }, []);

  const handleClose = () => {
    track("Job Locked Payment Clicked", {
      eventId: "job-locked-payment-clicked",
    });
    onClose();
  };

  return (
    <Dialog
      open
      classes={{ paper: styles.paper }}
      BackdropProps={{
        classes: { root: styles.backdrop },
      }}
    >
      <DialogTitle hasCloseButton={false}>Unlocking soon</DialogTitle>
      <DialogContent className={styles.content}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={"/images/jobs-payment-lock.svg"}
          alt="icon"
          className={styles.image}
        />
        <Typography variant="h6" className={styles.title}>
          Complete your trip payment and unlock the next phase of your journey -
          the job matching process!
        </Typography>
        <Typography
          color="text.secondary"
          variant="body1"
          className={styles.description}
        >
          Once your trip is paid in full, you&apos;ll be assigned your dedicated
          Arrival Coordinator and gain exclusive access to the Global Job Board
          closer to your arrival date.
        </Typography>
        <Button onClick={handleClose} className={styles.button}>
          Proceed to Payment
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentLockDialog;
